export default __webpack_public_path__ + "static/media/slide1.afe62d8e.jpg";